import {FieldsOptions} from '@sim/form';
import {FilterFieldsOptions} from '@ui/ui.module';

import {iccdDateValidator} from '@sim/form/validators';

import {CardRelation, CardRelationMeta, ICCDMeta} from '@atmi/core/models/cards/card';
import {CardShape, CardShapeMeta} from '@atmi/core/models/cards/card-shape';
import {
  RelationDMeta,
  RelationFMeta,
  RelationMIMeta,
  RelationOAMeta,
  RelationSMeta
} from '@atmi/core/models/cards/relation';
import {
  Base,
  EBaseType,
  Movement,
  SourceArcCard,
  SourceArchivial,
  SourceBibCard,
  SourceBibliographic
} from "@atmi/core/models";
import {Person} from "@sim/person";
import {Media} from "@sim/media";

/*@TODO mettere a number???*/
export interface MIS {
  /** Unità */
  MISU: string;
  /** Altezza */
  MISA: string;
  /** Lunghezza */
  MISL: string;
  /** Profondità */
  MISP: string;
  /** Peso */
  MISG: string;
  /** Varie */
  MISV: string[];
  /** Diametro */
  MISD: string;
  /** Lunghezza */
  MISN: string;
  /** Spessore */
  MISS: string;
  /**  */
  MISH: string;
  /**  */
  MISB: string;
  /** */
  MISI: string;
  /** Validità */
  MIST: string;
}

export interface ISR {
  /** Classe di appartenenza */
  ISRC: string;
  /** Tecnica di scrittura */
  ISRS: string;
  /** Posizione */
  ISRP: string;
  /** Trascrizione */
  ISRI: string;
}

export interface OperaMadre {
  tiratura: number;
  tiraturaEA: number;
  tiraturaHC: number;
}

export interface IBaseShort {
  base: string;
  tipo: EBaseType;
}

export interface CardOA extends CardRelation {
  forma: CardShape;
  patina?: string;
  /** Iscrizioni (ICCD) */
  ISR: ISR[];
  operaMadre?: OperaMadre;
  /** Misure (ICCD) */
  MIS: MIS;
  /** Id of the base */
  base?: string;
  basi: IBaseShort[];
  /** Id of the card OA parent */
  benePadre?: string;
  numeroEsemplare?: string;
  fornitore?: string;
  tipoOperaFiglia?: string;
}

//@TODO complete for print
export type CardOAJoined = Omit<CardOA, 'fornitore' | 'fontiBib' | 'fontiArc' | 'base' | 'benePadre'> & {
  base: Base | null;
  benePadre: CardOA | null;//serve per prendere dati dalla scheda madre nel caso di scheda figlia
  fornitore: Person | null;
  fontiBib: SourceBibliographic[];
  fontiBibGrouped: SourceBibliographic[][];
  fontiArc: SourceArchivial[];
  fontiArcGrouped: SourceArchivial[][];
  attachments: Media[];
  attachmentsGrouped: Media[][];
  movimentiGrouped: Movement[][];
  iscrizioniGrouped: ISR[][];
}

export interface CardOAFilter {
  codiceUnico?: string;
  ['SGT.SGTT']?: string;
  MTC?: string;
  base?: string;
  benePadre?: string | null;
  tipoOperaFiglia?: string | null;
  height?: string[] | null;
  width?: string[] | null;
  depth?: string[] | null;
}

export const OperaMadreMeta: FieldsOptions<OperaMadre> = {
  tiratura: {},
  tiraturaEA: {},
  tiraturaHC: {},
};

export const MISMeta: FieldsOptions<MIS> = {
  MISA: {},
  MISB: {},
  MISD: {},
  MISG: {},
  MISH: {},
  MISI: {},
  MISL: {},
  MISN: {},
  MISP: {},
  MISS: {},
  MIST: {validators: [iccdDateValidator()]},
  MISU: {value: 'cm'},
  MISV: {value: [], type: 'array'},
};

export const ISRMeta: FieldsOptions<ISR> = {
  ISRC: {},
  ISRI: {},
  ISRP: {},
  ISRS: {},
};

// FIXME: Why CardOA interface does not work
export const CardOAMeta: FieldsOptions<any> = {
  ...CardRelationMeta,
  AUT: {...ICCDMeta.AUT, value: [{AUTN: 'Igor Mitoraj', AUTA: 'Oederan, 26 marzo 1944 – Parigi, 6 ottobre 2014'}]},
  ISR: {controls: ISRMeta, type: 'array', value: {}, additionalInfo: {label: 'Iscrizioni'}},
  MIS: {type: 'object', controls: MISMeta, value: {}, additionalInfo: {label: 'Misure'}},
  TSK: {...ICCDMeta.TSK, value: 'OA'},
  base: {},
  basi:  {type: 'array', value: []},
  benePadre: {value: null},
  forma: {type: 'object', controls: CardShapeMeta},
  fornitore: {},
  numeroEsemplare: {value: ''},
  operaMadre: {value: {}, controls: OperaMadreMeta, type: 'object'},
  patina: {value: ''},
  relazioniBeniD: {type: 'array', controls: RelationDMeta, value: []},
  relazioniBeniF: {type: 'array', controls: RelationFMeta, value: []},
  relazioniBeniMI: {type: 'array', controls: RelationMIMeta, value: []},
  relazioniBeniOA: {type: 'array', controls: RelationOAMeta, value: []},
  relazioniBeniS: {type: 'array', controls: RelationSMeta, value: []},
  tipoOperaFiglia: {},
};

export const CardOAFiltersMeta: FilterFieldsOptions<CardOAFilter> = {
  MTC: {operator: 'begins_with'},
  base: {operator: 'equal', typeField: 'oid'},
  benePadre: {operator: 'equal', typeField: 'oid', value: null, isNullable: true},
  codiceUnico: {operator: 'begins_with'},
  ['SGT.SGTT']: {operator: 'begins_with'},
  tipoOperaFiglia: {operator: 'equal'},
  height: {operator: 'range', typeField: 'double', isRange: true, targetProp: 'MIS.MISA', isNullable: true},
  width: {operator: 'range', typeField: 'double', isRange: true, targetProp: 'MIS.MISL', isNullable: true},
  depth: {operator: 'range', typeField: 'double', isRange: true, targetProp: 'MIS.MISP', isNullable: true}
};

